"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePermissionsSchema = exports.updateRoleSchema = exports.createRoleSchema = exports.permissionEntrySchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
exports.permissionEntrySchema = zod_1.z.object({
    resource: common_1.objectIdSchema,
    add: zod_1.z.boolean().default(false),
    view: zod_1.z.boolean().default(false),
    viewOwnRecord: zod_1.z.boolean().default(false),
    edit: zod_1.z.boolean().default(false),
    editOwnRecord: zod_1.z.boolean().default(false),
    delete: zod_1.z.boolean().default(false),
    deleteOwnRecord: zod_1.z.boolean().default(false),
    actions: zod_1.z.array(zod_1.z.string()).default([]),
    customButton: zod_1.z.boolean().default(false),
});
exports.createRoleSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).trim(),
    changeServiceType: zod_1.z.boolean().optional(),
});
exports.updateRoleSchema = exports.createRoleSchema.partial();
exports.updatePermissionsSchema = zod_1.z.object({
    permissions: zod_1.z.array(exports.permissionEntrySchema),
});
//# sourceMappingURL=role.js.map